// extracted by mini-css-extract-plugin
export default {"root":"ContentPanel__root--dZDhr"};